import { render } from "./ModalHistorial.vue?vue&type=template&id=780b638e&scoped=true"
import script from "./ModalHistorial.vue?vue&type=script&lang=js"
export * from "./ModalHistorial.vue?vue&type=script&lang=js"

import "./ModalHistorial.vue?vue&type=style&index=0&id=780b638e&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780b638e"]])

export default __exports__